module.exports = __webpack_public_path__ + "static/ilmater-symbol-DND3_FnP-3c04a33ead797c04c00bdc6842c40342.webp";